import {
  Alert,
  Button,
  Card,
  CardContent,
  CardHeader,
  FormContainer,
  Grid,
  Stack,
  TextField,
} from '@all-manager/design-system-v2';
import useChangePasswordCard, { MIN_PASSWORD_LENGTH } from './useChangePasswordCard';

type Props = {
  email: string;
};

export default function ChangePasswordCard(props: Props) {
  const hook = useChangePasswordCard({ email: props.email });

  return (
    <Card>
      <CardHeader
        title="Mot de passe"
        subheader="Utilisé pour vous connecter à toutes vos copropriétés."
      />
      <CardContent>
        <FormContainer onSubmit={hook.handleSubmit} noValidate>
          {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}
          {/* Lets password managers attach the new password to the right account. */}
          <input type="email" name="email" value={props.email} autoComplete="username" readOnly hidden />
          <Grid container>
            <Grid size={{ xs: 12, md: 8, lg: 6 }}>
              <Stack spacing={2}>
                <TextField
                  label="Mot de passe actuel"
                  type="password"
                  autoComplete="current-password"
                  value={hook.fields.currentPassword}
                  onChange={hook.handleFieldChange('currentPassword')}
                  error={Boolean(hook.errors.currentPassword)}
                  helperText={hook.errors.currentPassword}
                  required
                  fullWidth
                />
                <TextField
                  label="Nouveau mot de passe"
                  type="password"
                  autoComplete="new-password"
                  value={hook.fields.newPassword}
                  onChange={hook.handleFieldChange('newPassword')}
                  error={Boolean(hook.errors.newPassword)}
                  helperText={hook.errors.newPassword ?? `Au moins ${MIN_PASSWORD_LENGTH} caractères.`}
                  required
                  fullWidth
                />
                <TextField
                  label="Confirmer le nouveau mot de passe"
                  type="password"
                  autoComplete="new-password"
                  value={hook.fields.confirmation}
                  onChange={hook.handleFieldChange('confirmation')}
                  error={Boolean(hook.errors.confirmation)}
                  helperText={hook.errors.confirmation}
                  required
                  fullWidth
                />
              </Stack>
            </Grid>
          </Grid>
          <Stack direction="row">
            <Button
              type="submit"
              variant="contained"
              size="small"
              loading={hook.isSaving}
              disabled={!hook.canSubmit}
            >
              Modifier le mot de passe
            </Button>
          </Stack>
        </FormContainer>
      </CardContent>
    </Card>
  );
}
